import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/service/auth.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { HomeService } from 'src/app/service/home.service';
import { Apollo } from 'apollo-angular';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SharedService } from 'src/app/service/shared.service';
import { ErrorModalComponent } from '../error-modal/error-modal.component';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'trpx-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss'],
})
export class HeaderMenuComponent implements OnInit {
  @Input() componentName: string = '';
  @Input() landingLogo: any;
  @Input() showHeader: boolean | undefined;

  toggleSearch: boolean = false;
  isLogin: boolean = false;
  countryList: any;
  userName: string = '';
  customerProfile = this.authService.getCustomer();
  showSubMenu = false;
  @ViewChild('signin', { static: true })
  signin!: ElementRef;
  showCountryDrop = false;
  showCurrencyDrop = false;
  showCountryDropMob = false;
  showCurrencyDropMob = false;
  @Input() activeTab: string = '';
  tripLogo: string = '/assets/icons/logo.webp';
  logoSrc!: string;
  checkingWhiteLabel: boolean = false;

  modalRef?: BsModalRef;
  timestamp = new Date().getTime();

  loginForm: any = FormGroup;
  private dataSubscription: Subscription = new Subscription();

  countryDetailsData: any;
  currencyList: any = [];
  selectedCountry: any = null;
  selCountryCode: any = null;
  selectedCurrency: any = null;
  travelAgent: any = null;
  selectedCountryName: any;
  isCountryApiCalled = false;
  isCurrencyApiCalled = false;
  cartCount = 0;
  homeUrl: string = '/';
  subScribeLogo: any;
  baseUrl: any;
  isReloaded = false;
  // tripLogo: string = '/assets/icons/logo.webp';
  // logoSrc!: string;

  errorModalRef?: BsModalRef;
  isYusafir: any;

  constructor(
    private apollo: Apollo,
    public router: Router,
    public homeService: HomeService,
    private modalService: BsModalService,
    public authService: AuthService,
    private toastr: ToastrService,
    private elementRef: ElementRef,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.selectedCountry = localStorage.getItem('Trip_Country') ?? null;
      this.selCountryCode = localStorage.getItem('Trip_CountryCode') ?? null;
      this.selectedCurrency = localStorage.getItem('Trip_Currency') ?? null;
      this.travelAgent = localStorage.getItem('Trip_Travel_Agent') ?? null;
    }
    this.dataSubscription = this.homeService.country$.subscribe((data) => {
      this.selectedCountry = data;
      if (this.selectedCountry) this.setCountryName();
    });

    this.dataSubscription = this.homeService.currency$.subscribe((data) => {
      this.selectedCurrency = data;
    });

    this.getCountryDetails();
    this.getCurrencyDetails();

    this.dataSubscription = this.authService.customers$.subscribe((data) => {
      if (data == '404') {
        this.openModal(this.signin);
        this.authService.logout();
      } else this.customerProfile = data;
    });

    this.dataSubscription = this.homeService.cartCount$.subscribe((data) => {
      this.cartCount = data;
    });

    this.route.queryParams.subscribe((params) => {
      this.activeTab = params['type'];
    });
    if (isPlatformBrowser(this.platformId)) {
      this.isYusafir = window.location.hostname.includes('yusafir');
      this.baseUrl = this.getHostURL();
      if (
        this.baseUrl != environment.websiteOrigin &&
        !this.baseUrl.includes('clubmahindra')
      ) {
        const whiteLabelCalled = localStorage.getItem('whiteLabelCalled');
        if (!whiteLabelCalled) {
          this.getWhiteLabelDetails();
        } else {
          this.sharedService.updateWhiteLabelStatus(true);
        }
      } else {
        localStorage.removeItem('whiteLabelCalled');
        localStorage.removeItem('white_label_source');
        localStorage.removeItem('club_mahindra_token');
        localStorage.removeItem('logoSrc');
        this.sharedService.updateWhiteLabelStatus(true);
      }
    } else {
      this.sharedService.updateWhiteLabelStatus(true);
    }
  }

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.customerProfile = this.authService.getCustomer();
    this.cartCount = this.customerProfile?.cart_count || 0;
    this.checkIfTokenValid();
    this.subscribeLogo();
    this.getQueryParameters();
  }

  subscribeLogo() {
    this.sharedService.logoChange$.subscribe((res) => {
      this.subScribeLogo = res;
    });
  }

  getLogo() {
    return localStorage.getItem('logoSrc') || this.logoSrc || this.tripLogo;
  }

  gethomeUrl() {
    return localStorage.getItem('homeUrl') || this.homeUrl;
  }

  getHostURL(): string {
    return window.location.origin;
  }

  getWhiteLabelDetails() {
    this.checkingWhiteLabel = true;
    this.logoSrc = this.tripLogo;
    this.authService.whiteLabelValidation().subscribe((response) => {
      this.logoSrc = response?.logo || this.tripLogo;
      this.homeUrl = response?.logo_href || this.homeUrl;
      const whiteLabelCalled = localStorage.getItem('whiteLabelCalled');
      // if (!whiteLabelCalled) {
      //   if (this.homeUrl != this.router.url) this.router.navigate([this.homeUrl]);
      // }
      this.authService.setLogo(response?.logo);
      this.authService.setCustomer(response?.customer_profile);
      this.authService.setSource(response?.source);

      localStorage.setItem('whiteLabelCalled', 'true');
      localStorage.setItem('logoSrc', this.logoSrc);
      localStorage.setItem('homeUrl', this.homeUrl);
      if (!this.isReloaded) {
        this.reloadCurrentRoute();
        this.isReloaded = true;
      }
    });
  }

  getQueryParameters() {
    let tokenId;
    this.route.queryParams.subscribe((params: any) => {
      tokenId = params?.token;
      if (tokenId && !this.baseUrl.includes('yesrewards')) {
        let token = {
          token: tokenId,
        };
        this.logoSrc = '';
        this.authService.clubmahindraValidation(token).subscribe((response) => {
          if (response.status == 'fail') {
            this.authService.logout();
            return;
          }
          this.customerProfile = response?.customer_profile;
          this.authService.setToken(response?.token?.access);
          this.authService.setRefreshToken(response?.token?.refresh);
          this.authService.setCustomer(response?.customer_profile);
          this.authService.setClubMahindra(response?.token?.access);
          this.logoSrc = response?.logo || this.tripLogo;
          this.authService.setLogo(response?.logo);
          if (!this.isReloaded) {
            this.reloadCurrentRoute();
            this.isReloaded = true;
          }
        });
      } else {
        const details = this.authService.checkIfCMCustomerExists();
        if (details) {
          this.logoSrc = this.authService.getLogo() || this.tripLogo;
        } else {
          this.logoSrc = !this.checkingWhiteLabel ? this.tripLogo : '';
        }
      }
    });
  }

  checkIfTokenValid() {
    if (isPlatformBrowser(this.platformId)) {
      const token = localStorage.getItem('token');
      const refreshTime = localStorage.getItem('refreshtime');

      if (refreshTime && token) {
        // const currentTime = new Date().getTime();
        // const differenceInHours = (currentTime - parseInt(refreshTime, 10)) / (1000 * 60 * 60);

        // if (differenceInHours > 18) {
        const parsedToken = JSON.parse(token);
        this.authService
          .checkIfTokenValid(parsedToken)
          .subscribe((result: any) => {
            if (!result.is_valid) {
              this.authService.logout();
            }
          });
        // }
      }
    }
  }

  checkRefreshToken(): void {
    if (isPlatformBrowser(this.platformId)) {
      let refreshtime = localStorage.getItem('refreshtime') || '0';
      if (this.authService.isRefreshToken()) {
        if (new Date().getTime() - parseInt(refreshtime) > 6.48e7) {
          this.getTokenRefresh();
        }
      }
    }
  }

  getTokenRefresh() {
    if (isPlatformBrowser(this.platformId)) {
      this.authService
        .getTokenFromRefresh({
          refresh: localStorage.getItem('refreshtoken'),
        })
        .subscribe((result) => {
          if (result?.access) {
            this.authService.setToken(result?.access);
            localStorage.setItem(
              'refreshtime',
              JSON.stringify(new Date().getTime())
            );
          } else this.logout();
        });
    }
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(currentUrl);
    });
  }

  setCountryName() {
    // let country = this.countryDetailsData.find((ae: any) => ae.id == this.selectedCountry);
    // this.selectedCountryName = country?.countryName;
    let country = this.countryDetailsData?.find(
      (ae: any) => ae.id == this.selectedCountry
    );
    if (country) {
      this.selectedCountryName = country?.countryName;
    } else {
      // Handle the case where country is not found
      // console.error('Country not found for id:', this.selectedCountry);
    }
  }

  getCountryDetails() {
    if (isPlatformBrowser(this.platformId)) {
      this.apollo
        .watchQuery({
          query: this.homeService.country,
        })
        .valueChanges.subscribe(({ data }: any) => {
          this.countryDetailsData = data?.country;
          this.homeService.updateCountryList(this.countryDetailsData);
          localStorage.setItem('Trip_Country', this.countryDetailsData[0]?.id);
          localStorage.setItem(
            'Trip_CountryCode',
            this.countryDetailsData[0]?.countryCode
          );
          this.selectedCountry = this.countryDetailsData[0]?.id;
          this.selCountryCode = this.countryDetailsData[0]?.countryCode;
          this.selectedCountryName = this.countryDetailsData[0]?.countryName;
          this.homeService.updateCountry(this.countryDetailsData[0]?.id);
          // }
        });
    }
  }

  getCurrencyDetails() {
    if (isPlatformBrowser(this.platformId)) {
      this.apollo
        .watchQuery({
          query: this.homeService.currency,
        })
        .valueChanges.subscribe(({ data }: any) => {
          const currentTime = Date.now();
          const previousSavedTime = localStorage.getItem('currencyTime') || '0';

          localStorage.setItem('currencyTime', JSON.stringify(currentTime));
          if (currentTime - JSON.parse(previousSavedTime) > 259200000)
            localStorage.removeItem('Trip_Currency');

          this.currencyList = data?.currency;
          this.homeService.updateCurrencyList(this.currencyList);
          this.selectedCurrency = localStorage.getItem('Trip_Currency');

          if (this.selectedCurrency) {
            this.homeService.updateCurrency(this.selectedCurrency);
          } else {
            localStorage.setItem('Trip_Currency', this.currencyList[0]?.code);
            this.selectedCurrency = this.currencyList[0]?.code;
            this.homeService.updateCurrency(this.currencyList[0]?.code);
          }
        });
    }
  }

  changeCountry(country: string) {
    if (isPlatformBrowser(this.platformId)) {
      this.selectedCountry = country;
      this.homeService.updateCountry(this.selectedCountry);
      const COUNTRY = this.countryDetailsData.find(
        (ae: any) => ae.id == this.selectedCountry
      );
      this.selCountryCode = COUNTRY?.countryCode;
      // this.setCountryName();
      localStorage.setItem('Trip_CountryCode', COUNTRY?.countryCode);
      this.showCountryDrop = false;
      this.showCountryDropMob = false;
      // this.reloadCurrentRoute();
    }
  }

  changeCurrency(currency: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.selectedCurrency = currency;
      this.homeService.updateCurrency(this.selectedCurrency);
      const CURRENCY = this.currencyList.find(
        (ae: any) => ae.code == this.selectedCurrency
      );
      this.selectedCurrency = CURRENCY?.code;
      this.showCurrencyDrop = false;
      this.showCurrencyDropMob = false;
      this.reloadCurrentRoute();
      this.closeMenu();
    }
  }

  openModal(template: any) {
    // this.openErrorModal('Logged In Successfully!', true, 3000, 'success');
    const modalConfig = {
      ignoreBackdropClick: true,
    };
    this.modalRef = this.modalService.show(template, {
      ...modalConfig,
      class: 'modal-dialog-centered',
      animated: true,
    });
    this.modalRef.onHide?.subscribe((reason: string | any) => {
      this.authService.updateLoginPopShown(false);
    });
  }

  closeModal() {
    this.modalRef?.hide();
  }

  onlogin(data: any) {}

  goToCart() {
    if (this.customerProfile) {
      this.router.navigate([`/cart`]);
    } else {
      this.openModal(this.signin);
    }
  }

  goToWishlist() {
    if (this.customerProfile) {
      this.router.navigate([`/profile`], { queryParams: { tab: 'wishlist' } });
    } else {
      this.openModal(this.signin);
    }
  }

  closeMenu() {
    this.removeMenuWidth();
  }

  displayMenu() {
    this.addMenuWidth();
  }

  addMenuWidth() {
    if (isPlatformBrowser(this.platformId)) {
      let elem = document.getElementById('menu');
      if (elem?.classList.contains('menu_width_none')) {
        elem.classList.remove('menu_width_none');
        elem.classList.add('menu_width');
      }
    }
  }

  removeMenuWidth() {
    if (isPlatformBrowser(this.platformId)) {
      let elem = document.getElementById('menu');
      if (elem?.classList.contains('menu_width')) {
        elem.classList.remove('menu_width');
        elem.classList.add('menu_width_none');
      }
    }
  }

  toggleMenuWidth() {
    if (isPlatformBrowser(this.platformId)) {
      let elem = document.getElementById('menu');
      if (elem) {
        if (elem.classList.contains('menu_width')) {
          elem.classList.remove('menu_width');
          elem.classList.add('menu_width_none');
        } else if (elem.classList.contains('menu_width_none')) {
          elem.classList.remove('menu_width_none');
          elem.classList.add('menu_width');
        }
      }
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    if (isPlatformBrowser(this.platformId)) {
      let element = document.querySelector('.header') as HTMLElement;
      if (window.pageYOffset > element.clientHeight) {
        element.classList.add('header-inverse');
      } else {
        element.classList.remove('header-inverse');
      }
    }
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (isPlatformBrowser(this.platformId)) {
      const dropdownCountryMob = this.elementRef.nativeElement.querySelector(
        '#dropdownCountryMob'
      );
      if (
        dropdownCountryMob &&
        !dropdownCountryMob.contains(event.target as Node)
      ) {
        this.showCountryDropMob = false;
      }

      const dropdownCurrencyMob = this.elementRef.nativeElement.querySelector(
        '#dropdownCurrencyMob'
      );
      if (
        dropdownCurrencyMob &&
        !dropdownCurrencyMob.contains(event.target as Node)
      ) {
        this.showCurrencyDropMob = false;
      }

      const dropdownCountry =
        this.elementRef.nativeElement.querySelector('#dropdownCountry');
      if (dropdownCountry && !dropdownCountry.contains(event.target as Node)) {
        this.showCountryDrop = false;
      }

      const dropdownCurrency =
        this.elementRef.nativeElement.querySelector('#dropdownCurrency');
      if (
        dropdownCurrency &&
        !dropdownCurrency.contains(event.target as Node)
      ) {
        this.showCurrencyDrop = false;
      }
    }
  }

  hideSubmenu() {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.showSubMenu = false;
      }, 1000);
    }
  }
 
  logout(isManual?: boolean) {
    if (isPlatformBrowser(this.platformId)) {
      this.authService.updateCustomer(null);
      if (isManual) this.toastr.warning('Logged Out Successfully!');
      // if (isManual) this.openErrorModal('Logged Out Successfully!', true, 3000, 'warning');
      this.authService.logout();
      let currentURL = this.router.url;
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigateByUrl(currentURL));
      if (this.travelAgent) {
        window.location.reload();
      }
    }
  }

  profilePage() {
    this.router.navigate([`/profile`]);
  }

  searchQuery = '';
  experianceSearchParam() {
    if (this.nullCheck(this.searchQuery)) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate([`/search-results`], {
          queryParams: { type: 'experiences', experience: this.searchQuery },
        })
      );
      this.trackSearch();
    } else {
      this.toastr.warning('Please Search Destination');
    }
  }
  nullCheck(vari: any) {
    if (vari != undefined && vari != null && vari != '') {
      return true;
    } else {
      return false;
    }
  }

  trackSearch(): void {
    if (isPlatformBrowser(this.platformId)) {
      console.log('Attempting to push search event');
      if (window && window.gtag) {
        window.gtag('event', 'search', {
          search_term: this.searchQuery,
          location: 'search_results',
        });
        console.log('search', {
          search_term: this.searchQuery,
          location: 'search_results',
        });
      } else {
        console.error('gtag function not found');
      }
    }
  }

  openErrorModal(errorData?: any, autoClose?: any, autoCloseTime?: number, modalColor?: string) {
    const initialState = {
      errorData: errorData,
      autoClose: autoClose, // Enable auto-close
      autoCloseTime: autoCloseTime, // Close after 3 seconds
      modalColor: modalColor,
    };

    this.errorModalRef = this.modalService.show(ErrorModalComponent, {
      class: 'modal-dialog-centered error-modal-style',
      animated: true,
      ignoreBackdropClick: true,
      initialState,
    });
  }

  ngOnDestroy() {
    this.dataSubscription.unsubscribe();
  }

  getCurrencySymbol(currency: any) {
    if (!currency || this.currencyList.length == 0) return '';
    const CURRENCY = this.currencyList.find((ae: any) => ae.code == currency);
    return CURRENCY?.symbol || '';
  }
}
